import EmptySearch from 'assets/Search/EmptySearch';
import { motion } from 'framer-motion';
import React from 'react';

const EmptySearchSection = () => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.25 }}
      className='flex items-center justify-center'
    >
      <div className='flex flex-col justify-center items-center sm:pb-[36px] pb-5 sm:pt-12 pt-8'>
        <EmptySearch className='mb-[26px] sm:w-[98px] w-[79px]' />
        <p className='text-white font-semibold sm:text-xl/[24px] text-base/6 sm:mb-1.5 mb-1 text-center'>
          Ups!... no results found
        </p>
        <p className='sm:text-sm/[22px] text-xs/5 text-white text-center'>
          Please try another search
        </p>
      </div>
    </motion.div>
  );
};

export default EmptySearchSection;
